import { supabase } from './supabase';

export type ConnectionEmbeddingsStatus = 'none' | 'pending' | 'ready' | 'error';

export function normalizeConnectionEmbeddingsStatus(
  raw: string | null | undefined,
): ConnectionEmbeddingsStatus {
  if (raw === 'pending' || raw === 'ready' || raw === 'error') return raw;
  return 'none';
}

/** Awaitable: rebuild pgvector row + updates connection_embeddings_status on the server. */
export async function runConnectionEmbeddingIndex(connectionId: number): Promise<{
  ok: boolean;
  deleted?: boolean;
  error?: string;
}> {
  if (!connectionId || connectionId < 1) {
    return { ok: false, error: 'Invalid connection id' };
  }
  const { data, error } = await supabase.functions.invoke<{
    ok?: boolean;
    deleted?: boolean;
    error?: string;
  }>('index-connection-embeddings', { body: { connection_id: connectionId } });
  if (error) {
    return { ok: false, error: error.message };
  }
  if (data && typeof data === 'object' && typeof data.error === 'string') {
    return { ok: false, error: data.error };
  }
  return { ok: true, deleted: Boolean(data?.deleted) };
}

/** Fire-and-forget; logs failures to the console. */
export function scheduleConnectionEmbeddingIndex(connectionId: number): void {
  void runConnectionEmbeddingIndex(connectionId).then((r) => {
    if (!r.ok) {
      console.warn('index-connection-embeddings:', r.error);
    }
  });
}
